import moment from 'moment';
import React from 'react';
import { Text } from '@/components/atoms/AppText';
import { FOOTER_PROPS } from '@/constant/layout/layout.constant';
import { tid } from '@/utils/testId';
import { LAYOUT_TEST_IDS as TID } from '@/constant/testIds/layout.testIds';

const Footer = ({ className = '' }: { className?: string }) => {
  const version = import.meta.env.VITE_APP_BUILD_INFO;

  return (
    <Text
      as="span"
      size="md"
      weight="light"
      color="subtle"
      data-testid={tid(TID.FOOTER)}
      className={`px-5 py-3 block mt-auto select-none pointer-events-none ${className}`}
    >
      <span className="font-medium">© {moment().year()} {FOOTER_PROPS.COMPANY_NAME} · {FOOTER_PROPS.ALL_RIGHTS_RESERVED}</span>{version ? ` v${version}` : ''}
    </Text>
  );
};

export default Footer;
